import { render, staticRenderFns } from "./PPTable.vue?vue&type=template&id=515c4d0d&scoped=true&"
import script from "./PPTable.vue?vue&type=script&lang=ts&"
export * from "./PPTable.vue?vue&type=script&lang=ts&"
import style0 from "./PPTable.vue?vue&type=style&index=0&id=515c4d0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c4d0d",
  null
  
)

export default component.exports